import * as React from "react";

import { asArrayValue } from "common/components/component-helpers";
import { LOADING, asUI } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

export const InlineListMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[list, itemUI]] = useForceValueProducers(getValueProducers, force, ctx);
    if (list === LOADING || itemUI === LOADING) {
        return null;
    }
    const arr = asArrayValue(list);
    return (
        <div>
            {arr.map((item, i) => (
                <React.Fragment key={i}>{asUI(itemUI).render(item, env.with({}))}</React.Fragment>
            ))}
        </div>
    );
};
